import UpdatePasswordForm from './UpdatePasswordForm';
import { userActions } from '../../redux/actions/userActions';
import { connect } from 'react-redux';
import queryString from 'query-string';

const mapStateToProps = ({
  authentication: { error, success },
  form: { UpdatePasswordForm },
  router
}) => {
  const query = queryString.parse(router.location.search);
  return {
    initialValues: { token: query && query.session },
    submitError:
      UpdatePasswordForm && UpdatePasswordForm.submitSucceeded && error,
    success: UpdatePasswordForm && UpdatePasswordForm.submitSucceeded && success
  };
};

const mapDispatchToProps = dispatch => ({
  onSubmit: ({ token, password }) =>
    dispatch(userActions.updatePassword(token, password))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UpdatePasswordForm);



// WEBPACK FOOTER //
// ./src/components/updatePassword/UpdatePasswordFormContainer.js